var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

import { PrimaryButton, Icon, Link, DetailsList, Spinner, SelectionMode, Breadcrumb } from "office-ui-fabric-react";
import * as React from "react";
import { NavigationType } from "../interfaces/index";

var DriveSelectionPanel =
/** @class */
function (_super) {
  __extends(DriveSelectionPanel, _super);

  function DriveSelectionPanel(props) {
    var _this = _super.call(this, props) || this;

    _this.setLocation = function () {
      if (_this.state.siteId == "" || _this.state.siteId == undefined || _this.state.driveId == "" || _this.state.driveId == undefined) return false;

      _this.props.selectDrive(_this.state.siteId, _this.state.driveId, _this.state.folderId || "");

      return true;
    };

    _this.state = {
      isLoading: true,
      items: [],
      breadcrumb: [],
      siteId: props.siteId || "",
      driveId: props.driveId || ""
    };
    return _this;
  }

  DriveSelectionPanel.prototype.componentDidMount = function () {
    this.loadInitialData();
  };

  DriveSelectionPanel.prototype.loadInitialData = function () {
    return __awaiter(this, void 0, void 0, function () {
      var items, items, items;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.state.siteId) return [3
            /*break*/
            , 5];
            if (!this.state.driveId) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.getFolders(this.state.siteId, this.state.driveId, "")];

          case 1:
            items = _a.sent();
            this.setState({
              isLoading: false,
              items: items,
              breadcrumb: [{
                key: "root",
                text: this.props.strings.Folders,
                onClick: this.onBreadcrumbClick.bind(this, undefined)
              }]
            });
            return [3
            /*break*/
            , 4];

          case 2:
            return [4
            /*yield*/
            , this.getDrives(this.state.siteId)];

          case 3:
            items = _a.sent();
            this.setState({
              isLoading: false,
              items: items,
              breadcrumb: [{
                key: "root",
                text: this.props.strings.Libraries,
                onClick: this.onBreadcrumbClick.bind(this, undefined)
              }]
            });
            _a.label = 4;

          case 4:
            return [3
            /*break*/
            , 7];

          case 5:
            return [4
            /*yield*/
            , this.getSites()];

          case 6:
            items = _a.sent();
            this.setState({
              isLoading: false,
              items: items,
              breadcrumb: [{
                key: "root",
                text: this.props.strings.Sites,
                onClick: this.onBreadcrumbClick.bind(this, undefined)
              }]
            });
            _a.label = 7;

          case 7:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  DriveSelectionPanel.prototype.getSites = function () {
    return __awaiter(this, void 0, void 0, function () {
      var sites, items;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.props.client.GetSitesForUser()];

          case 1:
            sites = _a.sent();
            items = [];
            sites.forEach(function (item) {
              if (item.displayName && item.id.indexOf("000000000000") == -1) items.push({
                displayName: item.displayName,
                path: item.relativeUrl,
                id: item.id,
                type: NavigationType.Site
              });
            });
            return [2
            /*return*/
            , items];
        }
      });
    });
  };

  DriveSelectionPanel.prototype.getDrives = function (siteId) {
    return __awaiter(this, void 0, void 0, function () {
      var drives, items;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.props.client.GetDrivesForSite(siteId)];

          case 1:
            drives = _a.sent();
            items = drives.map(function (item) {
              return {
                displayName: item.name,
                path: item.webUrl,
                id: item.id,
                type: NavigationType.Drive
              };
            });
            return [2
            /*return*/
            , items];
        }
      });
    });
  };

  DriveSelectionPanel.prototype.getFolders = function (siteId, driveId, folderParent) {
    return __awaiter(this, void 0, void 0, function () {
      var folders, items;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.props.client.GetFoldersInDrive(siteId, driveId, folderParent)];

          case 1:
            folders = _a.sent();
            items = folders.items.map(function (item) {
              return {
                displayName: item.name,
                path: folderParent + "/" + item.name,
                id: item.id,
                type: NavigationType.Folder
              };
            });
            return [2
            /*return*/
            , items];
        }
      });
    });
  };

  DriveSelectionPanel.prototype.Navigate = function (item) {
    return __awaiter(this, void 0, void 0, function () {
      var breadcrumbs, _a, items, items, items;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.setState({
              isLoading: true
            });

            if (this.state.breadcrumb[this.state.breadcrumb.length - 1].key != item.id) {
              breadcrumbs = __spreadArrays(this.state.breadcrumb);
              breadcrumbs.push({
                text: item.displayName,
                key: item.id,
                onClick: this.onBreadcrumbClick.bind(this, item)
              });
              this.setState({
                breadcrumb: breadcrumbs
              });
            }

            _a = item.type;

            switch (_a) {
              case NavigationType.Site:
                return [3
                /*break*/
                , 1];

              case NavigationType.Drive:
                return [3
                /*break*/
                , 3];

              case NavigationType.Folder:
                return [3
                /*break*/
                , 5];
            }

            return [3
            /*break*/
            , 7];

          case 1:
            return [4
            /*yield*/
            , this.getDrives(item.id)];

          case 2:
            items = _b.sent();
            this.setState({
              isLoading: false,
              items: items,
              siteId: item.id,
              driveId: "",
              folderId: "",
              currentPath: ""
            });
            return [3
            /*break*/
            , 7];

          case 3:
            return [4
            /*yield*/
            , this.getFolders(this.state.siteId, item.id, "")];

          case 4:
            items = _b.sent();
            this.setState({
              isLoading: false,
              items: items,
              driveId: item.id,
              folderId: "",
              currentPath: ""
            });
            return [3
            /*break*/
            , 7];

          case 5:
            return [4
            /*yield*/
            , this.getFolders(this.state.siteId, this.state.driveId, item.path)];

          case 6:
            items = _b.sent();
            this.setState({
              isLoading: false,
              items: items,
              currentPath: item.path,
              folderId: item.id
            });
            return [3
            /*break*/
            , 7];

          case 7:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  DriveSelectionPanel.prototype.onBreadcrumbClick = function (item) {
    return __awaiter(this, void 0, void 0, function () {
      var index, newBreadcrumbs;

      var _this = this;

      return __generator(this, function (_a) {
        if (!item) {
          // reset to start
          this.setState({
            siteId: this.props.siteId || "",
            driveId: this.props.driveId || "",
            folderId: "",
            currentPath: "",
            items: [],
            breadcrumb: []
          }, this.loadInitialData);
          return [2
          /*return*/
          ];
        }

        index = this.state.breadcrumb.findIndex(function (i) {
          return i.key == item.id;
        });
        newBreadcrumbs = this.state.breadcrumb.slice(0, index);
        this.setState({
          breadcrumb: newBreadcrumbs
        }, function () {
          return _this.Navigate(item);
        });
        return [2
        /*return*/
        ];
      });
    });
  };

  DriveSelectionPanel.prototype.render = function () {
    var _this = this;

    var columnName = this.props.strings.Site;
    if (this.state.driveId) columnName = this.props.strings.Folder;else if (this.state.siteId) columnName = this.props.strings.Library;

    if (this.state.isLoading) {
      return React.createElement(Spinner, {
        label: this.props.strings.Loading.replace("{0}", columnName),
        className: "center"
      });
    }

    var _columns = [{
      key: "displayName",
      name: columnName,
      onRender: function onRender(item) {
        return React.createElement(Link, {
          key: item.id,
          onClick: function onClick() {
            return _this.Navigate(item);
          }
        }, item.displayName);
      }
    }];
    return React.createElement("div", null, React.createElement("div", {
      className: "subTitle"
    }, React.createElement(Icon, {
      iconName: "ChevronLeftSmall",
      title: this.props.strings.Back,
      onClick: this.props.cancel,
      className: "backIcon"
    }), React.createElement("span", null, this.props.strings.ChooseLocation)), React.createElement("div", {
      className: "location"
    }, React.createElement("div", {
      className: "breadcrumb"
    }, React.createElement(Breadcrumb, {
      className: "breadCrumbNavigation",
      overflowIndex: 0,
      items: this.state.breadcrumb,
      maxDisplayedItems: 5
    })), React.createElement(DetailsList, {
      key: this.state.currentPath,
      items: this.state.items,
      columns: _columns,
      onItemInvoked: this.Navigate,
      selectionMode: SelectionMode.none
    }), React.createElement("br", null), React.createElement("div", {
      className: "buttonContainer"
    }, React.createElement(PrimaryButton, {
      text: this.props.strings.Next,
      onClick: this.setLocation,
      disabled: !this.state.siteId || !this.state.driveId
    }))));
  };

  return DriveSelectionPanel;
}(React.Component);

export { DriveSelectionPanel };